import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { Tree, Spin, Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import useState2RM from '../../hooks/useState2ReduxMock';
import { MailActions, useActions, useAppDispatch, MailClassifyActions, AttachmentActions, useAppSelector, ScheduleActions } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import CreateScheduleBox from '@web-schedule/components/CreateBox/CreateBox';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import CommentModal from '../../common/components/comment/CommentModal';
import { ScheduleSyncObInitiator } from '@web-schedule/data';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { getForbidMoveFolderIdList, folderList2CanMoveTree, folderId2Number, folderId2String, getTreeStatesByAccount, promiseIsTimeOut, isMac, folderIdIsAllFolder, folderList2CanAITidyUpTree, } from '../../util';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import Dialog from '@web-common/components/UI/Dialog/dialog';
import { idIsTreadMail } from '@web-common/utils/utils';
import './MailSyncModal.scss';
import { apiHolder as api, apis, getIn18Text, locationHelper, FLOLDER, } from 'api';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import MailReport from '../MailReport/MailReport';
import MailPrint from '../MailPrint/MailPrint';
import MailTodoModal from '../TodoMail/TodoMail';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { TagModal } from '../../components/MailTagList/MailTag';
import { MAIL_RECALL_LEVELS, MAIL_RECALL_MAX_DAY_LEVEL_MAP, MAIL_TAG_GUIDE_LOCAL_KEY } from '../../common/constant';
import ChatForward from '@web-im/subcontent/chatDisplay/chatForward';
import { TeamContactModel } from '@web-im/components/TeamCreator/teamCreator';
import MailDelivery from '../MailDelivery/MailDelivery';
import MailDeliveryWm from '../MailDelivery/MailDeliveryWm';
import PersonalOrgModal from '@web-common/components/UI/SiriusContact/personalOrgModal/personalOrg';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import MailDiscussModal from '@web-mail/components/ReadMail/component/MailDiscuss/mailDiscussModal';
import StatusModal from '@web-mail/components/StatusModal';
import useGetReadStatus from '@web-mail/components/ReadMail/hooks/useGetReadStatus';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import Alert from '@web-common/components/UI/Alert/Alert';
import { TagGuideModal } from '@web-mail/components/MailTagList/TagGuide';
import { getCatalogList, getSetting } from '@web-schedule/service';
import ScheduleInviteModal from '../ScheduleInviteModal/ScheduleInviteModal';
const systemApi = api.api.getSystemApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const eventApi = api.api.getEventApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const storeApi = api.api.getDataStoreApi();
const MailSyncModal = props => {
    var _a, _b;
    const [reportVisible, setReportVisible] = useState(false);
    const [reportConfig, setReportConfig] = useState();
    const [deliveryVisible, setDeliveryVisible] = useState(false);
    const [wMdeliveryVisible, setWmDeliveryVisible] = useState(false);
    const [mailId, setMailId] = useState(undefined);
    const [deliveryAccount, setDeliveryAccount] = useState(undefined);
    const [deliveryWay, setDeliveryWay] = useState(undefined);
    const printRef = useRef();
    const [listData, setListData] = useState();
    const [withDrawModalVisible, setWithDrawModalVisible] = useState(false);
    const [withDrawMailId, setWithDrawMailId] = useState();
    const [importConfirmLoading, setImportConfirmLoading] = useState(false);
    const { setModalAccount, setModalType, setMailSender, setMailTitle, changeShowClassifyModal } = useActions(MailClassifyActions);
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [isShowTreeMenu, setTreeMenu] = useState2RM('mailMoveModalVisiable', 'doUpdateMailMoveModalVisiable');
    const [isShowImportTreeMenu, setImportTreeMenu] = useState2RM('mailImportModalVisible', 'doUpdateMailImportModalVisible');
    const [activeIds, setActiveIds] = useState2RM('activeIds', 'doUpdateActiveIds');
    const [moveModalMailNum, setMoveModalMailNum] = useState2RM('mfModalReadMailNum', 'doUpdateMfModalReadMailNum');
    const [selectedMenuKeys, setSelectedMenuKeys] = useState2RM('mfModalSelectedFids', 'doUpdateMfModalSelectedFids');
    const [mailMoveMid, setMailMoveMid] = useState2RM('mailMoveMid', 'doUpdateMailMoveMid');
    const [mailImportMid, setMailImportMid] = useState2RM('mailImportMid', 'doUpdateMailMoveMid');
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [expandedMenuKeys, setExpandedMenuKeys] = useState2RM('mfModalExpandFids', 'doUpdateMfModalExpandFids');
    const [isModalVisible, setModalVisible] = useState2RM('commonModalVisible', 'doUpdateCommonModalVisible');
    const [resetDialog, setDialog] = useState2RM('dialogConfig', 'doUpdatedialogConfig');
    const [isShowAISelectTreeMenu, setAISelectTreeMenu] = useState2RM('mailAITidyUpModalVisiable', 'doUpdateMailAITidyUpModalVisiable');
    const [expandedAISelectMenuKeys, setExpandedAISelectMenuMenuKeys] = useState([]);
    const [AISelectedMenuKeys, setAISelectedMenuKeys] = useState([]);
    const [AISelectedMenuMboxData, setAISelectedMenuMboxData] = useState([]);
    const [mailTreeStateMap] = useState2RM('mailTreeStateMap');
    const [mailMoveFid, setMailMoveFid] = useState2RM('mailMoveFid', 'doUpdateMailMoveFid');
    const [shareMail, doUpdateShareMail] = useState2RM('shareMail', 'doUpdateShareMail');
    const [showGlobalLoading, setShowGlobalLoading] = useState2RM('showGlobalLoading', 'doUpdateShowGlobalLoading');
    const [addTagModalVisible, setAddtagModalVisible] = useState2RM('mailTagAddModalVisible', 'doUpdateMailTagAddModalVisible');
    const [mailTagMarkMailList, setMailTagMarkMailList] = useState([]);
    const attachmentActions = useActions(AttachmentActions);
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const [defaultPersonalOrgSelect, setDefaultPersonalOrgSelect] = useState([]);
    const [personalOrgModalVisible, setPersonalOrgModalVisible] = useState(false);
    const [personalOrgAccount, setPersonalOrgAccount] = useState(undefined);
    const sendingMails = useAppSelector(state => { var _a; return (_a = state.mailReducer) === null || _a === void 0 ? void 0 : _a.sendingMails; });
    const [mailTagGuideModalVisable, setMailTagGuideModalVisable] = useState(false);
    const closeTabRef = useRef();
    const { scheduleEvent: icsEventDetail, scheduleEditFrom, catalogList } = useAppSelector(state => state.scheduleReducer);
    const { changeScheduleEvent, setScheduleEditFrom, updateCatlogList, setSettingZoneList, setShowSecondaryZone } = useActions(ScheduleActions);
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const mailActions = useActions(MailActions);
    const shareMailMid = useAppSelector(state => state.mailReducer.shareMailMid);
    const paidGuideModal = useNiceModal('paidGuide');
    const [commentVisible, setCommentVisible] = useState(false);
    const [commentMemo, setCommentMemo] = useState('');
    const [commentMemoAccount, setCommentMemoAccount] = useState('');
    const [MailDiscussModalVisiable, setMailDiscussModalVisiable] = useState(false);
    const [mailDicussModalKey, setMailDicussModalKey] = useState(null);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const handleDiscussClose = () => {
        setMailDiscussModalVisiable(false);
        setMailDicussModalKey(null);
    };
    const MenuConfig = useMemo(() => {
        let defaultTitle = `移动${activeIds && activeIds.length ? moveModalMailNum : 1}封邮件到...`;
        if (folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            const userInfo = systemApi.getCurrentUser(mailMoveMid.accountId);
            defaultTitle = `移动${activeIds && activeIds.length ? moveModalMailNum : 1}封邮件到 ` + ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.agentEmail) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) + ' 的:';
        }
        return {
            title: defaultTitle,
            width: '500px',
            wrapClassName: 'u-move-dialog',
            style: {
                maxHeight: '480px',
            },
        };
    }, [activeIds === null || activeIds === void 0 ? void 0 : activeIds.length, moveModalMailNum, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, mailMoveMid]);
    const ImportMenuConfig = Object.assign(Object.assign({}, MenuConfig), { title: getIn18Text('DAORU1FENGYOU') });
    const data2tree = (data, isLocalImport) => {
        const forbidFidList = getForbidMoveFolderIdList(mailMoveFid, isSearching, selectedKeys.id, isLocalImport);
        return folderList2CanMoveTree(data, forbidFidList, 'move-folder-item');
    };
    const onSelectMenuFid = (_, { node }) => {
        node.key = folderId2Number(node.key);
        setSelectedMenuKeys([node.key]);
    };
    const data2AITidyUpAvailableTree = (data) => {
        const supportFidList = [FLOLDER.DEFAULT];
        return folderList2CanAITidyUpTree(data, supportFidList, 'move-folder-item');
    };
    const onSelectForAITidyUp = (_, { node }) => {
        console.log('xxx', _, node);
        node.key = folderId2Number(node.key);
        setAISelectedMenuKeys([node.key]);
        setAISelectedMenuMboxData([node]);
    };
    const onConfirmSelectForAITidyUp = () => {
        eventApi.sendSysEvent({
            eventName: 'AIAssistantEvent',
            eventStrData: 'folderSelected',
            eventData: AISelectedMenuMboxData[0],
            eventSeq: 0,
            noPost: true,
            asInnerMsg: true,
        });
        setAISelectTreeMenu(false);
    };
    const onConfirmMove = () => {
        dispatch(Thunks.doMoveMailFromModal({
            mailId: mailMoveMid === null || mailMoveMid === void 0 ? void 0 : mailMoveMid.mailId,
            folderId: selectedMenuKeys[0],
        }));
    };
    const onConfirmImport = () => {
        setImportConfirmLoading(true);
        setTimeout(() => {
            mailApi
                .doUploadMail(mailImportMid, selectedMenuKeys[0])
                .then(v => {
                Message.success({ content: getIn18Text('DAORUCHENGGONG'), duration: 1 }).then();
                setImportTreeMenu(false);
                eventApi.sendSysEvent({
                    eventName: 'initPage',
                    eventData: v.mid,
                    eventSeq: 0,
                    noPost: true,
                    asInnerMsg: true,
                });
                setShowGlobalLoading(true);
            })
                .catch(e => {
                console.warn(getIn18Text('YOUJIANDAORUSHI'), e);
                Message.error({ content: e || getIn18Text('YOUJIANDAORUSHI') }).then();
            })
                .finally(() => {
                setImportConfirmLoading(false);
            });
        }, 350);
    };
    const onCancelImport = () => {
        setImportTreeMenu(false);
        setImportConfirmLoading(false);
    };
    const refreshFolder = (noCache = false) => {
        promiseIsTimeOut(dispatch(Thunks.refreshFolder({
            noCache,
        })), 'pc_refreshFolder_timeout', {
            from: 'MailSyncModal',
        });
    };
    useEffect(() => {
        (shareMail === null || shareMail === void 0 ? void 0 : shareMail.entry) && trackApi.track('pcMail_click_shareMail');
    }, [shareMail]);
    const shareDiscussModal = useMemo(() => {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            (shareMail === null || shareMail === void 0 ? void 0 : shareMail.entry) && !shareMailMid && (React.createElement(ChatForward, { msgs: { mailMid: (_a = shareMail === null || shareMail === void 0 ? void 0 : shareMail.entry) === null || _a === void 0 ? void 0 : _a.id, mailTid: ((_b = shareMail === null || shareMail === void 0 ? void 0 : shareMail.entry) === null || _b === void 0 ? void 0 : _b.tid) || '' }, type: "shareText", onVisibleChange: () => mailActions.doUpdateShareMail({}) })),
            !!shareMailMid && (React.createElement(TeamContactModel, { show: !!shareMailMid, onCancel: () => {
                    mailActions.doUpdateShareMail({});
                    mailActions.doUpdateShareMailMid('');
                }, creatorType: 1, mid: shareMailMid }))));
    }, [shareMail, shareMailMid]);
    useEffect(() => {
        if ((isShowTreeMenu || !!isShowImportTreeMenu) && (!mailTreeStateMap || mailTreeStateMap.main.mailFolderTreeList.length == 0)) {
            dispatch(Thunks.refreshFolder({
                noCache: false,
            }));
        }
    }, [isShowTreeMenu, isShowImportTreeMenu]);
    useEffect(() => {
        setTimeout(() => {
            if ((catalogList === null || catalogList === void 0 ? void 0 : catalogList.length) <= 0) {
                getCatalogList().then(res => {
                    updateCatlogList(res);
                });
            }
            getSetting().then((res) => {
                var _a, _b, _c, _d, _e;
                setShowSecondaryZone(!!((_a = res === null || res === void 0 ? void 0 : res.commonSetting) === null || _a === void 0 ? void 0 : _a.showSecondaryZone));
                if (((_b = res === null || res === void 0 ? void 0 : res.commonSetting) === null || _b === void 0 ? void 0 : _b.secondaryZoneIds) && ((_d = (_c = res === null || res === void 0 ? void 0 : res.commonSetting) === null || _c === void 0 ? void 0 : _c.secondaryZoneIds) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    setSettingZoneList([...(_e = res === null || res === void 0 ? void 0 : res.commonSetting) === null || _e === void 0 ? void 0 : _e.secondaryZoneIds]);
                }
            });
        }, 5000);
    }, []);
    const toggleNewPersonalGroup = async (params, _account) => {
        const email2NameMap = {};
        const emails = params.map(item => {
            email2NameMap[item.email] = item.name;
            return item.email;
        });
        const contactRes = await contactApi.doGetContactByEmailFilter({ emails, _account });
        const contactResKeys = Object.keys(contactRes);
        const diff = emails.filter(item => !contactResKeys.includes(item));
        let resContent = [];
        if (diff.length > 0) {
            await new Promise((r, j) => {
                SiriusModal.error({
                    title: '联系人中有陌生邮箱地址，需要添加个人通讯录再创建分组。是否添加？',
                    cancelText: '跳过',
                    okText: '添加',
                    onOk: () => {
                        const insertParams = emails.map(item => {
                            return {
                                name: email2NameMap[item] || item.split('@')[0],
                                emailList: [item],
                                _account,
                            };
                        });
                        contactApi
                            .doInsertContact({
                            list: insertParams,
                            _account,
                        })
                            .then(res => {
                            r(res.data);
                        })
                            .catch(e => {
                            r([]);
                        });
                    },
                    onCancel: () => {
                        const list = Object.values(contactRes);
                        r(list ? list : []);
                    },
                });
            }).then((list) => {
                resContent = list;
            });
        }
        else {
            contactResKeys.forEach(item => {
                if (contactRes[item]) {
                    resContent.push(contactRes[item]);
                }
            });
        }
        return resContent;
    };
    const getReplyForwardCloseStore = () => {
        const replyForwardCloseData = storeApi.getSync('replyForwardClose', { noneUserRelated: true }).data;
        if (!replyForwardCloseData) {
            if (isMac())
                return false;
            return true;
        }
        return replyForwardCloseData === 'true';
    };
    const replyForwardCloseMain = (tab) => {
        const { id, extra } = tab;
        if (!id)
            return;
        const replyForwardClose = getReplyForwardCloseStore();
        if (replyForwardClose) {
            if (locationHelper.testPathMatchBoundary('readMail')) {
                systemApi.closeWindow();
            }
            else {
                try {
                    if ((extra === null || extra === void 0 ? void 0 : extra.originMid) && idIsTreadMail(extra === null || extra === void 0 ? void 0 : extra.originMid))
                        return;
                    dispatch(mailTabActions.doCloseTab(id));
                }
                catch (error) {
                    console.log('关闭失败', error);
                }
            }
        }
    };
    const closeCurReadTabBefore = (ev) => {
        if (locationHelper.testPathMatchBoundary('readMail'))
            return;
        console.log('closeCurReadTab_before', currentTab, ev);
        closeTabRef.current = null;
        const { closeable, id, type, extra } = currentTab;
        const { opt } = ev.eventData;
        if (closeable && type === 'read' && id) {
            closeTabRef.current = { id, opt, extra };
        }
    };
    const closeCurReadTabAfter = (ev) => {
        var _a;
        if (locationHelper.testPathMatchBoundary('readMail')) {
            if (getReplyForwardCloseStore()) {
                systemApi.closeWindow();
            }
            return;
        }
        console.log('closeCurReadTab_after', ev, closeTabRef.current);
        const { opt } = ev.eventData;
        if (((_a = closeTabRef === null || closeTabRef === void 0 ? void 0 : closeTabRef.current) === null || _a === void 0 ? void 0 : _a.opt) === opt) {
            replyForwardCloseMain(closeTabRef === null || closeTabRef === void 0 ? void 0 : closeTabRef.current);
            closeTabRef.current = null;
        }
    };
    const freeVerionSizeOver = (ev) => {
        paidGuideModal.show({ errType: '41', origin: '邮箱转发' });
    };
    const { openRecordData, setOpenRecordData, readStatus, setReadStatus, debounceGetStatusOrDetail, getStatusOrDetail, formatReadStatusByProduct } = useGetReadStatus();
    const [readStatusVisbale, setReadStatusVisbale] = useState(false);
    const [readStatusMailData, setReadStatusMailData] = useState();
    const refreshData = useCreateCallbackForEvent(() => {
        const id = readStatusMailData === null || readStatusMailData === void 0 ? void 0 : readStatusMailData.id;
        if (!id)
            return;
        getStatusOrDetail(readStatusMailData);
    });
    const mailReadStatusElement = useMemo(() => {
        var _a;
        return readStatusVisbale ? (React.createElement(StatusModal, { tid: (_a = readStatusMailData === null || readStatusMailData === void 0 ? void 0 : readStatusMailData.entry) === null || _a === void 0 ? void 0 : _a.tid, readListData: readStatus, onClose: () => {
                setReadStatusVisbale(false);
                setReadStatusMailData(null);
            }, visible: readStatusVisbale, refreshData: refreshData })) : (React.createElement(React.Fragment, null));
    }, [readStatusVisbale, readStatus, readStatusMailData]);
    const doCheckList = useCallback((_id, _account) => {
        mailApi.doCheckReadStatus(_id, _account).then(data => {
            var _a, _b;
            if (data.detail.length) {
                const list = formatReadStatusByProduct(data.detail);
                const sucList = (_a = list.data) === null || _a === void 0 ? void 0 : _a.filter(item => item.status === 'suc');
                setReadStatus(list);
                if ((sucList === null || sucList === void 0 ? void 0 : sucList.length) === ((_b = list.data) === null || _b === void 0 ? void 0 : _b.length)) {
                    message.success({ content: getIn18Text('QUANBUCHEHUICHENG'), duration: 2 });
                }
                else {
                    setReadStatusVisbale(true);
                }
            }
            else {
                message.warn({ content: getIn18Text('QUANBUCHEHUISHI'), duration: 2 });
            }
        });
    }, []);
    const retractEmail = (content, showRes) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!content)
            return;
        const mid = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id;
        const account = content === null || content === void 0 ? void 0 : content._account;
        const findRes = sendingMails.find(item => item.id === mid);
        if (findRes) {
            message.warn({ content: getIn18Text('FASONGZHONGBUKECHEHUI') });
            return;
        }
        try {
            let accountAlias = ((_c = (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.prop) === null || _c === void 0 ? void 0 : _c.accountAlias) || [];
            if (Array.isArray(accountAlias)) {
                accountAlias = accountAlias.map(item => item.toLowerCase());
            }
            else if (typeof accountAlias === 'string') {
                accountAlias = accountAlias.toLowerCase();
            }
            const currentUser = ((_g = (_f = (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.accountName) === null || _g === void 0 ? void 0 : _g.toLowerCase()) || '';
            if (!(accountAlias === null || accountAlias === void 0 ? void 0 : accountAlias.includes(currentUser))) {
                const _all = Alert.warn({
                    title: getIn18Text('CHEHUISHIBAI'),
                    content: getIn18Text('CIYOUJIANFAJIAN'),
                    funcBtns: [
                        {
                            text: getIn18Text('QUEDING'),
                            type: 'primary',
                            onClick: () => {
                                _all.destroy();
                            },
                        },
                    ],
                });
                return;
            }
        }
        catch (e) {
            console.error('retractEmail', e);
        }
        const productInfo = systemApi.doGetProductInfo();
        const productVersionId = productInfo.navigateVersion ? 'navigateVersion' : productInfo.productVersionId;
        const level = MAIL_RECALL_MAX_DAY_LEVEL_MAP[productVersionId];
        const maxDay = MAIL_RECALL_LEVELS[level];
        const sendTime = ((_h = content === null || content === void 0 ? void 0 : content.entry) === null || _h === void 0 ? void 0 : _h.sendTime) ? new Date(content.entry.sendTime).getTime() : null;
        const now = Date.now();
        if (sendTime && now - sendTime > maxDay) {
            const alertInstance = Alert.warn({
                title: getIn18Text('CHEHUISHIBAI'),
                content: level === 'v2' ? getIn18Text('CIYOUJIANJFSSYCG3TWF2') : getIn18Text('CIYOUJIANJUFA'),
                funcBtns: [
                    {
                        text: getIn18Text('QUEDING'),
                        type: 'primary',
                        onClick: () => {
                            alertInstance.destroy();
                        },
                    },
                ],
            });
            return;
        }
        if (showRes) {
            mailApi.doCheckReadStatus(mid, account).then(data => {
                if (data.detail.length) {
                    const list = formatReadStatusByProduct(data.detail);
                    setReadStatus(list);
                    setReadStatusVisbale(true);
                }
            });
        }
        else {
            if (localStorage.getItem('backNmr') === 'true') {
                const key = 'withdraw....';
                message.loading({ content: getIn18Text('ZHENGZAICHEHUIYOU'), key });
                mailApi.doWithdrawMail(mid, readStatus === null || readStatus === void 0 ? void 0 : readStatus.tid, account).then((res) => {
                    var _a;
                    message.destroy(key);
                    if ((res === null || res === void 0 ? void 0 : res.status) === 'S_OK' && ((_a = res === null || res === void 0 ? void 0 : res.detail) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                        message.success({ content: getIn18Text('QUANBUCHEHUICHENG'), duration: 2 });
                    }
                    else {
                        doCheckList(mid, account);
                    }
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            id: mid,
                        },
                        eventStrData: 'retractEmailSuccess',
                    });
                });
                return;
            }
            const al = Alert.warn({
                title: getIn18Text('QUEDINGYAOCHEHUI'),
                content: getIn18Text('CHEHUICHENGGONGHOU'),
                nmrText: getIn18Text('BUZAITIXING'),
                funcBtns: [
                    {
                        text: getIn18Text('QUXIAO'),
                        onClick: () => al.destroy(),
                    },
                    {
                        text: getIn18Text('CHEHUI'),
                        type: 'primary',
                        nmr: !0,
                        onClick: (event, nmrChecked) => {
                            if (nmrChecked) {
                                localStorage.setItem('backNmr', 'true');
                            }
                            const key = 'withdraw....';
                            message.loading({ content: getIn18Text('ZHENGZAICHEHUIYOU'), key });
                            mailApi
                                .doWithdrawMail(mid, readStatus === null || readStatus === void 0 ? void 0 : readStatus.tid, account)
                                .then((res) => {
                                var _a;
                                message.destroy(key);
                                al.destroy();
                                if ((res === null || res === void 0 ? void 0 : res.status) === 'S_OK' && ((_a = res === null || res === void 0 ? void 0 : res.detail) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                                    message.success({ content: getIn18Text('QUANBUCHEHUICHENG'), duration: 2 });
                                }
                                else {
                                    doCheckList(mid);
                                }
                                eventApi.sendSysEvent({
                                    eventName: 'mailMenuOper',
                                    eventData: {
                                        id: mid,
                                    },
                                    eventStrData: 'retractEmailSuccess',
                                });
                            })
                                .catch(err => {
                                message.destroy(key);
                            });
                        },
                    },
                ],
            });
        }
    };
    useMsgRenderCallback('mailMenuOper', ev => {
        var _a, _b, _c, _d, _e;
        const { _account } = ev;
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'move') {
            const { mailId, folderId } = ev.eventData;
            reducer.showMailMoveModal({
                mailId: mailId,
                accountId: _account,
                folderId,
            });
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'comment') {
            const { mailId, memo } = ev.eventData;
            const { _account } = ev;
            setCommentMemoAccount(_account || '');
            setCommentMemo(memo);
            setCommentVisible(true);
            setMailId(mailId);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'delete') {
            const { mailId: id, isThread, params, folderId } = ev.eventData;
            dispatch(Thunks.deleteMail(Object.assign(Object.assign({ id }, params), { showLoading: params === null || params === void 0 ? void 0 : params.showLoading, isScheduleSend: params === null || params === void 0 ? void 0 : params.isScheduleSend, detail: params === null || params === void 0 ? void 0 : params.detail, folderId: folderId })));
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'bulkDelete') {
            const { params, map, fid } = ev.eventData;
            dispatch(Thunks.showDeleteMultiMailDialog(Object.assign(Object.assign({ map: map }, params), { isScheduleSend: params === null || params === void 0 ? void 0 : params.isScheduleSend, fid: fid })));
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'report') {
            const { mailId, hasReport, senderEmail } = ev.eventData;
            setReportConfig({
                mailId,
                hasReport,
                senderEmail,
            });
            setReportVisible(true);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'delivery') {
            const { mailId, account, way } = ev.eventData;
            if (process.env.BUILD_ISEDM || navigateVersion) {
                setMailId(mailId);
                setDeliveryAccount(account);
                setDeliveryWay(way);
                setWmDeliveryVisible(true);
            }
            else {
                setMailId(mailId);
                setDeliveryAccount(account);
                setDeliveryWay(way);
                setDeliveryVisible(true);
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'print') {
            const { _account } = ev;
            const { mailId, isThread, isPreview = false } = ev.eventData;
            if (!isThread) {
                (_a = printRef === null || printRef === void 0 ? void 0 : printRef.current) === null || _a === void 0 ? void 0 : _a.printMail(mailId, _account, isPreview);
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'setFromGroup') {
            const { senderEmail, title } = ev.eventData;
            setMailSender(senderEmail);
            setMailTitle(title);
            setModalAccount(_account);
            setModalType('edit');
            changeShowClassifyModal(true);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'attachmentPreview') {
            attachmentActions.doAttachmentPreview(ev.eventData);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'share') {
            doUpdateShareMail(ev === null || ev === void 0 ? void 0 : ev.eventData);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'importMail') {
            const { cid } = ev.eventData;
            refreshFolder();
            setTimeout(() => {
                reducer.showMailImportModal({
                    mailId: cid,
                });
            }, 50);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'closeMailWindow') {
            systemApi.closeWindow(true);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'addTagAndMark') {
            const { mailList: list } = ev.eventData;
            if (list && list.length > 0) {
                setAddtagModalVisible({
                    accountId: _account,
                    visible: true,
                });
                setMailTagMarkMailList(list);
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'newGuideForAside') {
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'back') {
            if (((_b = currentTab === null || currentTab === void 0 ? void 0 : currentTab.extra) === null || _b === void 0 ? void 0 : _b.cmMidList) && ((_d = (_c = currentTab === null || currentTab === void 0 ? void 0 : currentTab.extra) === null || _c === void 0 ? void 0 : _c.cmMidList) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                dispatch(mailTabActions.doUpdateCMBack());
            }
            else {
                dispatch(mailTabActions.doChangeCurrentTab(((_e = currentTab === null || currentTab === void 0 ? void 0 : currentTab.extra) === null || _e === void 0 ? void 0 : _e.from) || '-1'));
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'completeTrust') {
            const { mailId } = ev.eventData;
            mailApi.doCompleteTrustMail([mailId]).then(v => {
                reducer.doMailOperation(Object.assign({}, ev));
            });
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'createPersonalGroup') {
            const receiverEmails = ev.eventData.receiverEmails;
            if (receiverEmails && receiverEmails.length && !personalOrgModalVisible) {
                toggleNewPersonalGroup(receiverEmails, _account)
                    .then((res) => {
                    if (res && res.length) {
                        const params = res.map(item => contactApi.transContactModel2ContactItem(item));
                        setDefaultPersonalOrgSelect(params);
                    }
                    else {
                        setDefaultPersonalOrgSelect([]);
                    }
                    setPersonalOrgModalVisible(true);
                    setPersonalOrgAccount(_account);
                })
                    .catch(e => {
                    Toast.error({ content: '创建个人分组失败' });
                });
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'closeCurReadTab_before') {
            closeCurReadTabBefore(ev);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'closeCurReadTab_after') {
            closeCurReadTabAfter(ev);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'discussion') {
            const { mailId, tid } = ev.eventData;
            setMailDiscussModalVisiable(true);
            setMailDicussModalKey({
                mid: mailId,
                tid,
            });
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'freeVerionSizeOver') {
            freeVerionSizeOver(ev);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'showMailReadState') {
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'retractEmail') {
            const { mailData, showRes } = ev.eventData;
            retractEmail(mailData, showRes);
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'markProcessFollow') {
            const { ids, mark, track, showMessage, accounts } = ev.eventData;
            dispatch(Thunks.markProcessFollow({
                ids,
                accounts,
                mark,
                showMessage,
            }));
            if (track && (process.env.BUILD_ISEDM || navigateVersion)) {
                trackApi.track('waimao_mail_click_processButton_mailListPage', {
                    buttonName: mark ? '标为已跟进' : '标为待跟进',
                    folderName: (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.UNFOLLOW ? '无挡待跟进' : '有挡待跟进',
                });
            }
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'showMailTagGuideModal') {
            const { visiable } = ev.eventData;
            setMailTagGuideModalVisable(visiable);
            localStorage.setItem(MAIL_TAG_GUIDE_LOCAL_KEY, 'true');
        }
        else if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'mailTagGuideModalClose') {
        }
    });
    useMsgRenderCallback('AIAssistantEvent', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'folderSelect') {
            setAISelectedMenuKeys([]);
            setExpandedAISelectMenuMenuKeys([]);
            setAISelectedMenuMboxData([]);
            reducer.showMailAITidyUpModal({});
        }
    });
    const mailMoveTreeList = useMemo(() => {
        var _a;
        const res = mailTreeStateMap && (mailMoveMid === null || mailMoveMid === void 0 ? void 0 : mailMoveMid.accountId) && getTreeStatesByAccount(mailTreeStateMap, mailMoveMid.accountId)
            ? (_a = getTreeStatesByAccount(mailTreeStateMap, mailMoveMid.accountId)) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList
            : [];
        return res;
    }, [mailTreeStateMap, mailMoveMid]);
    const mailAITidyUpTreeList = useMemo(() => {
        const allAccountFolders = [
            {
                key: '100000000',
                title: '所有收件箱',
                children: [],
            },
        ];
        for (let key in mailTreeStateMap) {
            const _mailTreeState = mailTreeStateMap[key];
            if (_mailTreeState.expired)
                continue;
            allAccountFolders.push({
                key: _mailTreeState.accountId,
                title: _mailTreeState.accountId,
                selectable: false,
                children: _mailTreeState.mailFolderTreeList.map(item => {
                    return Object.assign(Object.assign({}, data2AITidyUpAvailableTree(item)), { mboxData: item, accountId: _mailTreeState.accountId });
                }),
            });
        }
        return allAccountFolders;
    }, [mailTreeStateMap]);
    const hasCustomFolder = useMemo(() => {
        var _a;
        return mailTreeStateMap && (mailMoveMid === null || mailMoveMid === void 0 ? void 0 : mailMoveMid.accountId) && getTreeStatesByAccount(mailTreeStateMap, mailMoveMid.accountId)
            ? (_a = getTreeStatesByAccount(mailTreeStateMap, mailMoveMid.accountId)) === null || _a === void 0 ? void 0 : _a.hasCustomFolder
            : [];
    }, [mailTreeStateMap, mailMoveMid]);
    const handelCreateCancel = () => {
        changeScheduleEvent(null);
        setScheduleEditFrom('');
    };
    const IcsScheduleModel = useMemo(() => {
        var _a, _b;
        let isOrg = false;
        if (icsEventDetail) {
            let user = systemApi.getCurrentUser();
            isOrg = ((_b = (_a = icsEventDetail.scheduleInfo) === null || _a === void 0 ? void 0 : _a.organizer) === null || _b === void 0 ? void 0 : _b.extDesc) == (user === null || user === void 0 ? void 0 : user.id);
        }
        return scheduleEditFrom === 'mail' && !!icsEventDetail ? (isOrg ? (React.createElement(CreateScheduleBox, { source: ScheduleSyncObInitiator.MAIL_MODULE, onCancel: handelCreateCancel, getReferenceElement: () => document.body })) : (React.createElement(ScheduleInviteModal, { onCancel: handelCreateCancel }))) : (React.createElement(React.Fragment, null));
    }, [icsEventDetail]);
    const showEmptyFolderTip = useMemo(() => {
        let selectedFolderId = 0;
        try {
            if (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) {
                selectedFolderId = parseInt((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) + '');
            }
        }
        catch (e) {
            console.error('[showEmptyFolderTip Error]', e);
        }
        return !hasCustomFolder && (selectedFolderId < 0 || isSearching);
    }, [hasCustomFolder, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, isSearching]);
    return (React.createElement(React.Fragment, null,
        commentVisible && React.createElement(CommentModal, { visible: commentVisible, setVisible: setCommentVisible, mailId: mailId || '', memo: commentMemo, account: commentMemoAccount }),
        React.createElement(SiriusModal, Object.assign({}, MenuConfig, { visible: isShowTreeMenu, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), okButtonProps: { disabled: !(selectedMenuKeys === null || selectedMenuKeys === void 0 ? void 0 : selectedMenuKeys.length) }, onOk: onConfirmMove, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), onCancel: () => setTreeMenu(false), bodyStyle: { overflow: 'auto' }, destroyOnClose: true }),
            React.createElement("div", { className: "m-tree-container m-move-tree" }, showEmptyFolderTip ? (React.createElement("div", { className: "no-custom-folder-wrap" },
                React.createElement("div", { className: "ncf-logo " },
                    React.createElement("div", { className: "sirius-empty sirius-empty-search" })),
                React.createElement("div", { className: "ncf-title" }, getIn18Text('JINZHICHIPILIANG')))) : (React.createElement(Tree, { selectedKeys: folderId2String(selectedMenuKeys), showIcon: true, onExpand: keys => {
                    setExpandedMenuKeys(folderId2Number(keys));
                }, expandedKeys: folderId2String(expandedMenuKeys), treeData: mailMoveTreeList === null || mailMoveTreeList === void 0 ? void 0 : mailMoveTreeList.map((treeData) => data2tree(treeData)), icon: React.createElement(ReadListIcons.FolderSvg, null), onSelect: onSelectMenuFid, blockNode: true })))),
        React.createElement(SiriusModal, Object.assign({}, MenuConfig, { title: getIn18Text('XUANZEWENJIANJIA'), visible: isShowAISelectTreeMenu, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), okButtonProps: { disabled: !(AISelectedMenuKeys === null || AISelectedMenuKeys === void 0 ? void 0 : AISelectedMenuKeys.length) }, onOk: onConfirmSelectForAITidyUp, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), onCancel: () => setAISelectTreeMenu(false), bodyStyle: { overflow: 'auto' }, destroyOnClose: true }),
            React.createElement("div", { className: "m-tree-container m-move-tree" },
                React.createElement(Tree, { selectedKeys: folderId2String(AISelectedMenuKeys), showIcon: true, onExpand: keys => {
                        setExpandedAISelectMenuMenuKeys(keys);
                    }, expandedKeys: expandedAISelectMenuKeys, treeData: mailAITidyUpTreeList, icon: React.createElement(ReadListIcons.FolderSvg, null), onSelect: onSelectForAITidyUp, blockNode: true }))),
        React.createElement(SiriusModal, Object.assign({}, ImportMenuConfig, { visible: isShowImportTreeMenu, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), onCancel: onCancelImport, bodyStyle: { overflow: 'auto' }, destroyOnClose: true, footer: [
                React.createElement(Button, { key: "confirm", onClick: onCancelImport, className: "local-import-btn" }, getIn18Text('QUXIAO')),
                React.createElement(Button, { key: "confirm", type: "primary", onClick: onConfirmImport, disabled: !(selectedMenuKeys === null || selectedMenuKeys === void 0 ? void 0 : selectedMenuKeys.length), loading: importConfirmLoading, className: "local-import-btn" }, getIn18Text('QUEDING')),
            ] }),
            React.createElement("div", { className: "m-tree-container m-move-tree" },
                React.createElement(Tree, { selectedKeys: folderId2String(selectedMenuKeys), showIcon: true, onExpand: keys => {
                        setExpandedMenuKeys(folderId2Number(keys));
                    }, expandedKeys: folderId2String(expandedMenuKeys), treeData: (_b = (_a = mailTreeStateMap.main) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList) === null || _b === void 0 ? void 0 : _b.map((treeData) => data2tree(treeData, true)), icon: React.createElement(ReadListIcons.FolderSvg, null), onSelect: onSelectMenuFid, blockNode: true }))),
        React.createElement(MailReport, { visible: reportVisible, setVisible: setReportVisible, mailId: reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.mailId, hasReport: reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.hasReport, senderEmail: reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.senderEmail }),
        process.env.BUILD_ISEDM || navigateVersion ? (React.createElement(MailDeliveryWm, { visible: wMdeliveryVisible, setVisible: setWmDeliveryVisible, account: deliveryAccount, mailId: mailId, way: deliveryWay })) : (React.createElement(MailDelivery, { visible: deliveryVisible, setVisible: setDeliveryVisible, account: deliveryAccount, way: deliveryWay, mailId: mailId })),
        React.createElement(MailPrint, { ref: printRef }),
        React.createElement(MailTodoModal, null),
        (addTagModalVisible === null || addTagModalVisible === void 0 ? void 0 : addTagModalVisible.visible) && (React.createElement(TagModal, { account: addTagModalVisible === null || addTagModalVisible === void 0 ? void 0 : addTagModalVisible.accountId, type: "add", markWhenAdd: true, data: [], activeIds: mailTagMarkMailList, afterClose: () => {
                setAddtagModalVisible(false);
            } })),
        showGlobalLoading ? (React.createElement("div", { className: "global-modal-warp" },
            React.createElement(Spin, { wrapperClassName: "global-modal-spin", tip: React.createElement("div", { className: "global-modal-spin-tip" }, getIn18Text('CAOZUOZHENGZAIJIN')), indicator: React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true }) },
                React.createElement("div", { className: "global-modal" })))) : (React.createElement(React.Fragment, null)),
        React.createElement(Dialog, Object.assign({ isModalVisible: isModalVisible, onCancel: setModalVisible, isCancel: true }, resetDialog)),
        shareDiscussModal,
        personalOrgModalVisible && (React.createElement(PersonalOrgModal, { defaultSelectedContact: defaultPersonalOrgSelect, _account: personalOrgAccount, onCancel: () => {
                setDefaultPersonalOrgSelect([]);
                setPersonalOrgModalVisible(false);
            }, onSure: () => {
                setDefaultPersonalOrgSelect([]);
                setPersonalOrgModalVisible(false);
            } })),
        React.createElement(TagGuideModal, { visiable: mailTagGuideModalVisable, onClose: () => setMailTagGuideModalVisable(false) }),
        mailReadStatusElement,
        React.createElement(MailDiscussModal, { keyIds: mailDicussModalKey, visiable: MailDiscussModalVisiable, onClosed: handleDiscussClose }),
        IcsScheduleModel));
};
export default MailSyncModal;
